import { Component } from "react";


const LAST_NAVIGATION_TYPE = {
   BACK: 'back',
   FORWARD: 'forward',
}

export default class NavigationStateSaver extends Component {

   static states = {}
   static lastNavigationType = null;

   getCurrentPath() {
      if (!this.___currentPath)
         this.___currentPath = window.location.pathname;
      return this.___currentPath;
   }

   async componentDidMount() {

      const path = this.getCurrentPath();

      if (NavigationStateSaver.lastNavigationType === LAST_NAVIGATION_TYPE.BACK) {
         const state = NavigationStateSaver.states[path]?.toReversed()[0];

         if (state) {
            await (new Promise((resolve) => {
               this.setState(state, () => {
                  resolve();
               });
            }));
         }
      }
   }

   async componentWillUnmount() {
      
      if (super.componentWillUnmount)
         await super.componentWillUnmount();

      const path = this.getCurrentPath();

      if (NavigationStateSaver.lastNavigationType === LAST_NAVIGATION_TYPE.BACK) {
         // remove the last state
         const states = NavigationStateSaver.states[path];
         if (states) {
            states.pop();
            if (states.length === 0)
               delete NavigationStateSaver.states[path];
         }
      } else if (NavigationStateSaver.lastNavigationType === LAST_NAVIGATION_TYPE.FORWARD) {
         let states = NavigationStateSaver.states[path];

         if (!states) {
            states = [];
            NavigationStateSaver.states[path] = states;
         }

         states.push(this.state);
      }

   }
   
}

let index = 0;
window.history.pushState({ idx: index }, null, window.location.href);

window.addEventListener('popstate', (event) => {
   if (typeof event.state?.idx === 'number') {
      const newIndex = event.state.idx;
      if (newIndex < index) {
         NavigationStateSaver.lastNavigationType = LAST_NAVIGATION_TYPE.BACK;
      } else if (newIndex > index) {
         NavigationStateSaver.lastNavigationType = LAST_NAVIGATION_TYPE.FORWARD;
      }

      index = newIndex;
   }

});

window.addEventListener("pushstate", (event) => {
   NavigationStateSaver.lastNavigationType = LAST_NAVIGATION_TYPE.FORWARD;
});

// raise pushstate event on history.pushState
(function () {
   const originalPushState = window.history.pushState;
 
   // Override pushState
   window.history.pushState = function (...args) {
     // Call the original pushState
     const result = originalPushState.apply(this, args);
 
     // Dispatch a custom event
     const pushStateEvent = new Event("pushstate");
     window.dispatchEvent(pushStateEvent);

     // Update the index
     const newIndex = args[0].idx;
     if (typeof newIndex === 'number')
        index = newIndex;
 
     return result;
   };
 })();
 
// TODO: merge this with Page.js